const memberServicePath = '/member-service/v2';
const memberServiceAccountPath = '/member-service/v2/account';
const oddsServicePath = '/sports-service/sv';
const betServicePath = '/bet-placement';
const vsServicePath = '/vs-service';
const templateServicePath = '/estharmb/data-resoures/template-layout';
const liveScoreServicePath = '/livescore-notifier';
const paymentServicePath = '/payment/web';
const iforiumServicePath = '/iforium-service';
const solidGameLaunchPath = 'sg/get-game-launch-url';
const captchaServicePath = '/captcha-mgmt';
const agGameImagePath = '/aggame/images/';
const ptGameImagePath = '/images/games/';
const WagerMode = {
    DANGER_ZONE: 'dz',
    LIVE_DELAY: 'ld'
}
const APIS = {

    /**
     * Get furured games event.
     */
    getFuturedGamesEvent: function(params) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/em-odds/events/feature?${params}&wm=${wm}`;
    },
    
    getEuroSportNormalEvents: (params)  => {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/odds/events?${params}&wm=${wm}`;
    },

    getEuroLiveGames: (params)  => {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/em-odds/events/live?${params}&wm=${wm}`;
    },

    getEuroSportSpecialEvents: (params)  => {
        return `${oddsServicePath}/em-outRight/odds?${params}`;
    },

    getEuroOddsEvents: (params)  => {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/em-odds/events?${params}&wm=${wm}`;
    },

    /**
     * Get statement info
     */
    getStatement: function(params) {
        return `${memberServicePath}/statement2?${params}`;
    },
    /**
     * get member-service path
     */
    getMemberServicePath: function () {
        return memberServicePath;
    },

    /**
     * AG game image path
     */
    getAgGameImagePath: function () {
      return agGameImagePath;
    },

    /**
     * PT game image path
     */
    getPTGameImagePath: function () {
      return ptGameImagePath;
    },
    
    /**
     * template-service
     */
    templateLoadURL: function () {
        let url = `${memberServicePath}/mb-config`; //from server
        return url;
    },

    getClickLogURL: function (query) {
        let url = `${memberServicePath}/affiliate/submit${query}`;
        return url;
    },

    templateLoadURLLocal: function (skinName) {
        let url = `${templateServicePath}/${skinName}.json`; //from local
        return url;
    },

    /**
     * member-service
     */
    memberLoginURL: function () {
        return `${memberServicePath}/login`;
    },
    memberLogoutURL: function () {
        return `${memberServicePath}/logout`;
    },

    accountBalanceURL: function () {
        return `${memberServicePath}/account-balance`;
    },

    accountFullInfoURL: function () {
        return `${memberServicePath}/account-full-info`;
    },

    dataNoCache: function () {
        return `${memberServicePath}/data.nocache`;
    },

    listSportHasLSURL: function () {
        return `${memberServicePath}/listSportHasLS`;
    },

    mybetURL: function () {
        return `${memberServicePath}/my-bets`;
    },

    bettingBudgetsURL: function () {
        return `${memberServicePath}/betting-budgets`;
    },

    multiUpdateOddsURL: function (selectionData) {
        return `${memberServicePath}/multiUpdateOdds?selectionData=${selectionData}`;
    },

    singleTicketURL: function (selectionData) {
        return `${memberServicePath}/ticket?selectionData=${selectionData}`;
    },

    multiTicketURL: function (selectionData) {
        return `${memberServicePath}/multiTicket?selectionData=${selectionData}`;
    },

    oddsSelectionsURL: function () {
      return `${memberServicePath}/odds-selections`;
    },
    
    specialTicketsURL: function () {
        return `${memberServicePath}/special-tickets`;
    },

    updateSpecialTicketsURL: function () {
        return `${memberServicePath}/update-special-tickets`;
    },

    oddsSelectionsUpdateURL: function () {
        return `${memberServicePath}/odds-selections-update`;
    },

    allOddsSelectionsURL: function () {
        return `${memberServicePath}/all-odds-selections`;
    },

    allOddsSelectionsUpdateURL: function () {
        return `${memberServicePath}/all-odds-selections-update`;
    },

    updateParlayTicketURL: (params) => {
        return `${memberServicePath}/update-parlay-ticket?${params}`;
    },

    announcementURL: function () {
        return `${memberServicePath}/announcement/list-limit`;
    },

    updateTimeReadURL: function () {
        return `${memberServicePath}/announcement/update-read-annoucement`;
    },

    announcementListURL: function (dataQueryParam) {
        return `${memberServicePath}/announcement/list?${dataQueryParam}`;
    },

    messageListURL: function (pageNo) {
        return `/member-service/message/list`;
    },


    lastMessageURL: function (dataQueryParam) {
        return `${memberServicePath}/message/lastMessage?${dataQueryParam}`;
    },

    activeProductsURL: function (pageNo) {
        return `${memberServicePath}/getActiveProducts`;
    },

    productFilterURL: function () {
        return `${memberServicePath}/getProductFilter`;
    },

    //product: all, casino, playtech, ion, ag, agin
    wagerFilterURL: function (product) {
        if (product === 'All')
            return `${memberServicePath}/wager-filter`;
        else {
            let strProd = product.toLowerCase();
            return `${memberServicePath}/${strProd}/wager-filter`;
        }
    },

    preferencesURL: function () {
        return `${memberServicePath}/preferences`;
    },
    
    quickStakeURL: function () {
        return `${memberServicePath}/quick-stake/get-info`;
    },

    resultsSportsURL: function (params) {
        return `${memberServicePath}/results/em-sports?${params}`;
    },

    resultsLeaguesURL: function (params) {
        return `${memberServicePath}/results/em-leagues?${params}`;
    },

    resultsEventsURL: function (params) {
        return `${memberServicePath}/results/events?${params}`;
    },

    selfExcludsionsURL: function (days) {
        if (days == null) {
            return `${memberServicePath}/self-excludsion`;
        }
        else {
            return `${memberServicePath}/self-excludsion?days=${days}`;
        }
    },

    sportsSortingURL: function (country) {
        return `${memberServicePath}/sports-sorting?c=${country}`;
    },

    saveSportsSortingURL: function () {
        return `${memberServicePath}/sports-sorting`;
    },

    /**
     * promotion service
     */
    getPromotionInfo: function (lng) {
        return `${memberServicePath}/slider/getPromotionInfo?lang=${lng}`;
    },

    validateWelcomeBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateWelcomeBonus`;
    },

    validateReactivationBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateReactivationBonus`;
    },

    validateCashbackRebateBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateCashbackRebateBonus`;
    },

    claimWelcomeBonus: function() {
      return `${memberServicePath}/bonusPromotion/claimWelcomeBonus`;
    },

    claimReactivationBonus: function() {
      return `${memberServicePath}/bonusPromotion/claimReactivationBonus`;
    },

    claimCashbackRebate: function() {
      return `${memberServicePath}/bonusPromotion/claimCashbackRebate`;
    },

    /** end */

    reportSystemErrorURL: function () {
        return `${memberServicePath}/report-system-error`;
    },

    acceptTCURL: function(promoEmail, version) {
        return `${memberServicePath}/acceptTC?promoEmail=${promoEmail}&version=${version}`
    },

    memberGetCountryAndCurrency: function() {
        return `${memberServicePath}/register/CountryAndCurrency?c=Others`
    },

    memberRefreshCaptcha: function() {
        return `${memberServicePath}/captcha?${new Date().getTime()}`
    },

    getCaptchaImage: function(category) {
        return `${captchaServicePath}/captcha/get?category=${category}&${new Date().getTime()}`
    },
    
    activationLink: function() {
        return `${memberServicePath}/register/rq_activation_link?originUrl=${window.location.origin}`
    },

    memberDoForgotUsername: function() {
        return `${memberServiceAccountPath}/doForgotUsername`
    },
    
    memberDoForgotEmail: function() {
        return `${memberServiceAccountPath}/doForgotEmail`
    },

    memberDoForgotPassword: function() {
        return `${memberServiceAccountPath}/doForgetPassword`
    },
    memberCheckLoginId: function() {
        return `${memberServicePath}/register/check-loginId`
    },
    memberDoSignUp: function() {
        return `${memberServicePath}/register/doSignup`
    },
    memberGetBanks: function() {
        return `${memberServicePath}/register/get-banks`
    },
    memberGetWallets: function(currency) {
        return `${memberServicePath}/register/get-wallets?currency=${currency}`
    },
    memberGetActivePayments: function() {
        return `${paymentServicePath}/bank/get-all-pc-active-deposit-payment-type`
    },

    memberGetSupportedPaymentTypes: function() {
        return `${paymentServicePath}/bank/get-supported-payment-type`
    },

    memberGetPinPayPaymentMethods: function() {
        return `${paymentServicePath}/bank/get-supported-payment-methods`
    },

    memberGetPinPaySupportedBanks: function() {
        return `${paymentServicePath}/bank/get-supported-banks`
    },

    memberAddBankingAccount: function() {
        return `${paymentServicePath}/bank/add`
    },
    /**
     * odds-service
     */
    sportsMarketURL: function (country, v) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/menu/sports-markets?c=${country}&v=${v}&wm=${wm}`;
    },

    playtechGamesURL: function () {
        return `${memberServicePath}/p/playtech-service/game.gameGroupHtml5`;
    },

    playtechGamesByIdURL: function (id) {
        return `${memberServicePath}/p/playtech-service/game.gameGroupHtml5/${id}`;
    },

    /**
     * asia odds-service
     */
    asiaSportsMarketURL: function (country, v) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/am/sports-markets?c=${country}&v=${v}&wm=${wm}`;
    },

    esportMarketURL: function (country, v) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/menu/esport-market?c=${country}&v=${v}`;
    },

    oddsEventsURL: function (dataQueryParam) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/odds/events?${dataQueryParam}&wm=${wm}`;
    },

    /**
     * Get Asia odds URL
     */
    asiaOddsEventsURL: function (dataQueryParam) {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/am/events?${dataQueryParam}&wm=${wm}`;
    },

    getDisplayPeriod: () => {
        return `${oddsServicePath}/odds/periods-default-setting`;
    },

    /**
     * Get Asia Outright odds URL
     */
    asiaOutrightOddsURL: function (dataQueryParam) {
      return `${oddsServicePath}/am/outright?${dataQueryParam}`;
    },

    /**
     * Get Asia eSport Outright odds URL
     */
    asiaEsportOutrightOddsURL: function (dataQueryParam) {
      return `${oddsServicePath}/am/e-sport/outright?${dataQueryParam}`;
    },

    classicSportsMarketURL: function (country) {
      return `${oddsServicePath}/menu/classic-sports-markets?c=${country}`;
    },
    /**
     * bet-placement
     */

    betPlacementBuyURL: function (uniqueRequestId) {
        return `${betServicePath}/buyV2?uniqueRequestId=${uniqueRequestId}`;
    },

    betPlacementMultiBuyURL: function (uniqueRequestId) {
        return `${betServicePath}/multiBuyV1?uniqueRequestId=${uniqueRequestId}`;
    },

    /**
     * vs-service
     */
    startBetURL: function (uniqueRequestId) {
        return `${vsServicePath}/game/start-bet`;
    },

    /**
     * Get outright leagues
     */
    
    getOutrightLeaguesURL: (sportId, lgName) => {
      if (lgName) { // for esports
        return `${oddsServicePath}/outRight/es-leagues?sportId=${sportId}&lgName=${lgName}`;  
      }
      return `${oddsServicePath}/outRight/leagues?sportId=${sportId}`;
    },

    /**
     * Get Asia outright leagues
     */
    
    getAsiaOutrightLeaguesURL: (parameters) => {
      return `${oddsServicePath}/am/outright/leagues?${parameters}`;
    },

    /**
     * Get normal leagues
     */
    getLeaguesURL: (sportParameters) => {
        return `${oddsServicePath}/odds/leagues?sp=${sportParameters.sp}&mk=${sportParameters.mk}&btg=${sportParameters.btg}&d=${sportParameters.d}&tm=${sportParameters.tm}&c=${sportParameters.c}&l=${sportParameters.l}&pa=${sportParameters.pa}`;
    },

    /**
     * Get esport leagues
     */
    getEsportLeaguesURL: (esportParams) => {
      return `${oddsServicePath}/odds/es-leagues?sp=${esportParams.sp}&mk=${esportParams.mk}&btg=${esportParams.btg}&d=${esportParams.d}&tm=${esportParams.tm}&c=${esportParams.c}&l=${esportParams.l}&pa=${esportParams.pa}&lgName=${esportParams.lgName}`;
    },

    /**
     * Get Asia eSport leagues
     */
    getAsiaEsportLeaguesURL: (esportParams) => {
      return `${oddsServicePath}/am/es-leagues?${esportParams}`;
    },

    /**
     * menu service
     */
    getLiveBetURL: (liveBetParameter) => {
        if (!liveBetParameter.showAll) {
            return `${oddsServicePath}/menu/live-sports-markets?ecnt=6`;
        } else {
            return `${oddsServicePath}/menu/live-sports-markets?stcnt=0&secnt=0&ecnt=0`;
        }
    },

     /**
     * Get Iframe url
     */
      getIframeUrl: (params) => {
        return `${memberServicePath}/iframe/get-iframe-url?${params}`;
    },

    /**
     * Get multi forecast url
     */
    getMultiForecastURL: () => {
        return `${memberServicePath}/account/multi-forecast`;
    },

    /**
     * Get forecast url
     */
    getForecastURL: (params) => {
        return `${memberServicePath}/account/forecast?eid=${params.eid}&selectionId=${params.selectionId}&stk=${params.stk}&oddsFm=${params.oddsFm}&odds=${params.odds}`;
    },

    /**
     * Get teaser ticket url
     */
    getTeaserTicketURL: (params) => {
        return `${memberServicePath}/teaser-ticket?teaserId=${params.teaserId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legs=${params.legs}`;
    },

    /**
     * Get favourite sports
     */
    getFavouriteSportURL: (params) => {
        return `${oddsServicePath}/menu/favouriteSports?eventIds=${params.eventIds}`;
    },
    /**
     * Get MyBets Data URL
     */
    getMyBetsURL: () => {
        return `${memberServicePath}/my-bets`;
    },
    /**
     * get DeleteMyBetsWager
     */
    getDeleteMyBetsWager: (dataQuery) => {
        return `${memberServicePath}/delete-wager?wagerId=${dataQuery.wagerId}`;
    },

    /**
     * Get Outright odds URL
     */
    outrightOddsURL: function (dataQueryParam) {
      // const keyQueryOutrightForEsport = 'eSportCode';
      // const match = RegExp('[?&]' + keyQueryOutrightForEsport + '=([^&]*)').exec(dataQueryParam);
      // if (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) {
      //   return `${oddsServicePath}/outRight/esport/odds?${dataQueryParam}`;
      // }
      return `${oddsServicePath}/outRight/odds?${dataQueryParam}`;
    },

    /**
     * Get Classic Outright odds URL
     */
    outrightOddsClassicURL: function (dataQueryParam) {
        const keyQueryOutrightForEsport = 'eSportCode';
        const match = RegExp('[?&]' + keyQueryOutrightForEsport + '=([^&]*)').exec(dataQueryParam);
        if (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) {
          return `${oddsServicePath}/outRight/esport/odds/classic?${dataQueryParam}`;
        }
        return `${oddsServicePath}/outRight/odds/classic?${dataQueryParam}`;
      },

    /**
     * Get Outright odds URL
     */
    outrightleagueURL: function (dataQueryParam) {
        return `${oddsServicePath}/outRight/leagues?${dataQueryParam}`;
    },

    /**
     * Get teaser odds URL
     */
    teaserOddsURL: function (dataQueryParam) {
        return `${oddsServicePath}/teaser/oddsAdvance?${dataQueryParam}`;
    },

    /**
     * Remove teaser ticket url
     */
    removeTeaserTicketURL: (params) => {
        return `${memberServicePath}/remove-teaser-ticket?teaserId=${params.teaserId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legId=${params.legId}`;
    },

    /**
     * Buy teaser bet URL
     */
    buyTeaserBetURL: function (uniqueRequestId) {
        return `${betServicePath}/buyTeaserV2?uniqueRequestId=${uniqueRequestId}`;
    },

    updateTeaserTicket: (params) => {
      return `${memberServicePath}/update-teaser-ticket?legId=${params.legId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legs=${params.legs}`;
    },

    removeParlayTicketUrl: (params) => {
        return `${memberServicePath}/remove-parlay-ticket?legId=${params.legId}&ticketId=${params.ticketId}&checkTicket=${params.checkTicket}&ot=${params.oddsFormat}`;
    },

    parlayRemoveSelectionsURL: (legId) => {
        return `${memberServicePath}/parlay-remove-selection?legId=${legId}`;
    },

    parlayOddsSelectionsURL: function () {
        return `${memberServicePath}/parlay-odds-selections`;
    },

    parlayUpdateOddsURL: function () {
        return `${memberServicePath}/parlay-update-odds`;
    },

    parlayUpdateTicket: function (params) {
        return `${memberServicePath}/update-parlay-ticket?${params}`
    },

    placeParlayBetURL: (uniqueRequestId) => {
        return `${betServicePath}/buyParlayV2?uniqueRequestId=${uniqueRequestId}`;
    },

    updatePitcherParlayURL: (params) => {
        return `${memberServicePath}/update-pitcher-parlay-ticket?legId=${params.legId}&pitcher1MustStart=${params.pitcher1MustStart}&pitcher2MustStart=${params.pitcher2MustStart}`;
    },

    getSliderBannerHomeURL: (params) => {
        return `${memberServicePath}/landing-mobile?lang=${params.lang}&c=${params.country}`
    },

    getAllMiniBannerURL: (params) => {
        return `${memberServicePath}/single/getAllMiniBanner?lang=${params.lang}&country=${params.country}`;
    },
    /*
    * Live Score Service
    */
    liverScoreUpdateNotify: () => {
        return `${liveScoreServicePath}/update-notify.sv`
    },

        /*
    * New Betslip Notify Service
    */
    newBetslipMobileNotify: () => {
        return `${memberServicePath}/mobile/new-betslip/accept-popup`
    },

    /**
     * Classic View
     */
    getClassicSportsMarkets: (sportId, leagueId, market, eventId)  => {
        return `${oddsServicePath}/classic/sport-markets?sportId=${sportId}&lg=${leagueId}&mk=${market}${eventId ? '&ev=' + eventId : ''}`;
    },

    getClassicEventOdds: (sportId, leagueId, market, marketType, oddsType, maxLines, eventId, order, version, timeZoneId)  => {
        let liveVersion, nonLiveVersion;
        if(market == 2) {
            nonLiveVersion  = version[0];
        } else {
            liveVersion = version[0];
            nonLiveVersion = version[1];
        }
        return `${oddsServicePath}/classic/events?sp=${sportId}&lg=${leagueId}&mk=${market}&l=${maxLines}&smt=${marketType}&ot=${oddsType}
            &o=${order}${eventId ? '&ev=' + eventId : ''}${liveVersion ? '&lv=' + liveVersion : ''}&tz=${timeZoneId}${nonLiveVersion ? '&v=' + nonLiveVersion : ''
        }`;
    },

    getClassicParlayEventOdds: (sportIds, leagueIds, market, oddsType, maxLines, isParlay, order, date, version, timeZoneId) => {
      return `${oddsServicePath}/classic/events?sp=${sportIds}&lg=${leagueIds}&l=${maxLines}&mk=${market}&ot=${oddsType}&pa=${isParlay}&o=${order}&tz=${timeZoneId}${version ? '&v=' + version : ''}${date ? '&d=' + date : ''}`;
    },

    /**
     * Canino
     * Get category
     */
    getCategory: () => {
      return `${memberServicePath}/casino/category`;
    },

    /**
     * Canino
     * Get live category
     */
    getLiveCategory: () => {
        return `${memberServicePath}/casino/live/category`;
    },

    /**
     * Get Casino sliders
     */
    getCasinoSlider: (casinoSliderFilter) => {
      return `${memberServicePath}/slider/getCasinoSlider?${casinoSliderFilter}`;
    },

    /**
     * Get Casino games
     */
    getCasinoGames: (casinoFilter) => {
      return `${memberServicePath}/casino/mobile-games?${casinoFilter}`;
    },

    /**
     * Get Casino games
     */
    getLiveCasinoGames: (casinoFilter) => {
        return `${memberServicePath}/casino/live/mobile-games?${casinoFilter}`;
    },

    /**
     * Get Iforium providers
     */
    getIforiumProviders: () => {
      return `${iforiumServicePath}/game/providers`;
    },

     /**
     * Canino - get Casino side bar
     */
    getCasinoSideBar: () => {
        return `${memberServicePath}/casino/getCasinoSideBars`;
    },

    /**
     * Canino - initGameflexExpressLibrayAPI
     */
    initGameflexExpressLibray: () => {
        return `${iforiumServicePath}/game/getGameflexExpressConfig`;
    },

    /**
     * Canino - getPlayerCurrencyCode
     */
    getPlayerCurrencyCode: () => {
        return `${iforiumServicePath}/player/getCurrencyCode`;
    },

    /**
     * Canino - getPlayerSession
     */
    getPlayerSession: () => {
        return `${iforiumServicePath}/player/sessiontoken`;
    },

    /**
     * Canino - getDefaultGameIdGRVs
     */
    getDefaultGameIdGRVs: (channelId) => {
      return `${memberServicePath}/casino/default-game-gr?${channelId}`;
    },


    /**
     * Golden Race VS - getPlayerSession
     */
    getPlayerSessionVs: () => {
        return `${iforiumServicePath}/player/sessiontokenvs`;
    },

    /**
     * Get accounts balance
     */
    getAccountsBalance: () => {
      return `${memberServicePath}/accounts-balance`;
    },

    /**
     * Transfer wallets
     */
    transferWallets: () => {
      return `${paymentServicePath}/transfer/process`;
    },

     /**
     * Get game dispatcher Url
     */
    getGameDispatcherUrl: (dataQueryParam) => {
      return `${memberServicePath}/getGameDispatcherUrl?${dataQueryParam}`;
    },

    /**
     * Get AG game dispatcher Url
     */
    getAGGameDispatcherUrl: (dataQueryParam) => {
      return `${memberServicePath}/getAGGameDispatcherUrl?${dataQueryParam}`;
    },

    /**
     * Get Solid game launcher Url
     */
    getSolidGameLaunchPath: function (gameCode) {
        return `${memberServicePath}/${solidGameLaunchPath}/${gameCode}`;
    },

    /**
     * Get casino login status
     */
    getCasinoLoginStatus: () => {
      return `${memberServicePath}/getCasinoLoginStatus`;
    },

    /**
     * Get CR855 game path
     */
    getCR855GamePath: function () {
      return `${memberServicePath}/crown-service/login`;
    },

    /**
     * Check Playtech player online
     */
    checkPlaytechPlayerOnline: () => {
      return `${memberServicePath}/p/playtech-service/player/online`;
    },

    /**
     * Logout playtech user
     */
    logoutPlaytechUser: () => {
        return `${memberServicePath}/p/playtech-service/player/logout`;
      },

    /**
     * Get playtech player
     */
    getPlaytechPlayer: () => {
      return `${memberServicePath}/playtech-service/login`;
    },

    /**
     * Get Casino Backround
     */
    getCasinoBackground: (dataQueryParam) => {
      return `${memberServicePath}/single/getCasinoBanner?${dataQueryParam}`;
    },

    /**
     * Get active product wallet
     */
    getActiveProductWallet: () => {
      return `${memberServicePath}/getActiveProductWallet`;
    },

    /**
     * Check Affiliate Code
     */
    checkAffiliateCode: () => {
      return `${memberServicePath}/register/check-affiliate`;
    },

    /**
     * Check Promo Code
     */
    checkPromoCode: () => {
        return `${memberServicePath}/register/doValidatePromotionCode`;
      },

    getWagerFilter : () => {
        return `${memberServicePath}/wager-filter`;
    },  
   getProfile : () => {
        return `${memberServicePath}/profile`;
    },

    getNgcUrl : (page, lang) => {
        return `${paymentServicePath}/ngc-api/generateUrl?page=${page}&lang=${lang}`;
    },

    changePassword : () => {
        return `${memberServicePath}/changePassword`;
    },
   
    changePasswordToLogin : () => {
        return `${memberServicePath}/changePasswordToLogin`;
    },

    /**Asia Betslip */
    getAsiaSingleOdds: function(params) {
        return `${memberServicePath}/ticket?${params}`;
    },
    getAsiaOutrightOdds: function(params) {
        return `${memberServicePath}/outright-ticket?${params}`;
    },
    /**
     * Update locale
     */
    updateLocale : (lang) => {
        return `${memberServicePath}/locale?lang=${lang}`;
    },

    getActiveWallets : () => {
        return `${memberServicePath}/getActiveWallets?_+${Math.random()}`;
    }, 

    getStatements : (dataQueryParam) => {
        return `${memberServicePath}/statement2?${dataQueryParam}`;
    },

    getMessages: function(dataQueryParam) {
        return `${memberServicePath}/message/mb-list?${dataQueryParam}`;
    },

    deleteMessageListURL: function () {
        return `${memberServicePath}/message/update-message-to-read`;
    },


    resultsSportsAsiaURL: function() {
        return `${memberServicePath}/results/sports`;
    },

    resultsLeaguesAsiaURL: function(dataQueryParam) {
        return `${memberServicePath}/results/leagues?${dataQueryParam}`;
    },
    getCountryAndCurrency: function() {
        return `${memberServicePath}/register/CountryAndCurrency`
    },
    getUserLocation: function() {
        return `https://ipinfo.io/json`
    },
    checkEmail: function() {
        return  `${memberServicePath}/register/check-email`
    },
    
    requestActivationURL: function(params) {
        return `${memberServicePath}/register/rq_activation_link`;
    },

    getB2BTransactionsURL : function() {
        return `${memberServicePath}/b2b/transaction/`;
    },

    getMaintenanceTemplate: () => {
      return `${memberServicePath}/getMaintenanceByLang`;
    },

    getLoginMessage: () => {
      return `${memberServicePath}/message/getLoginMessage`;
    },

    readLoginMessage: () => {
      return `${memberServicePath}/message/readLoginMessage`;
    },

    getPrestigeClubURL: (params) => {
      return `${memberServicePath}/prestige-club?${params}`;
    },

    updateDefaultView : (view) => {
        return `${memberServicePath}/updateDefaultView?defaultView=${view}`;
    }, 
    
    updateFingerPrintId: (dataQueryParam) => {
      return `${memberServicePath}/finger-print?${dataQueryParam}`;
    },

    getPromotionSurvey: (surveyId)  => {
        return `${memberServicePath}/promotion-survey/get-question?surveyId=${surveyId}`;
    },

    submitPromotionSurvey: () =>{
        return `${memberServicePath}/promotion-survey/submit-survey`;
    },

    getSportPeriodDesc: () =>{
      return `${oddsServicePath}/odds/periods`;
    },

    registerParticipantByCampaignId: function () {
        return `${memberServicePath}/campaign/participant`;
    },

    getBoardsByCampaignId: function (campaignId) {
        return `${memberServicePath}/campaign/board/${campaignId}`;
    },

    getScoresByCampaignId: function (campaignId) {
        return `${memberServicePath}/campaign/score/${campaignId}`;
    },

    getParticipantByCampaignId: function (campaignId) {
        return `${memberServicePath}/campaign/participant/${campaignId}`;
    },
    getActiveLink: (dataQueryParam) => {
      return `${memberServicePath}/register/activation_link?${dataQueryParam}`;
    },
    /**
     *  Multi-factor Authentication (MFA) 
     * 
    */
    getMfaSettingInfo: () => {
        return `${memberServicePath}/account/otp/getMfaSettingInfo`
    },
    setMfaMethodType: (params) => {
        return `${memberServicePath}/account/otp/setMfaMethodType?${params}`
    },
    getQRCode: () => {
        return `${memberServicePath}/account/otp/initQr`
    },
    getSecretKey: () => {
        return `${memberServicePath}/account/otp/initQrOtpCode`
    },
    saveQrOtp: (params) => {
        return `${memberServicePath}/account/otp/saveQrOtp?${params}`
    },
    getDGGameDispatcherUrl: (params) => {
        return `${memberServicePath}/getDGGameDispatcherUrl?${params}`
    },
    getUpdateReasonDpFailedURL: (params) => {
        return `${memberServicePath}/dp/floaded?${params}`
    },
    getDPIframeURL: (params) => `${window.env.dynamicParameterIframeUrl}?${params}`
}

export default APIS;



// WEBPACK FOOTER //
// ./src/app/common/config/APIs.js